import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectGroup,
  MultiSelectItem,
  MultiSelectTrigger,
  MultiSelectValue,
} from '../shadcn/multi-select';

export function ServerFilterMultiSelect({
  values,
  options,
  onChange,
  placeholder,
  formatLabel,
}: {
  values: string[];
  options: string[];
  onChange: (values: string[] | undefined) => void;
  placeholder: string;
  formatLabel?: (value: string) => string;
}) {
  return (
    <MultiSelect
      values={values}
      onValuesChange={(newValues) => {
        onChange(newValues.length > 0 ? newValues : undefined);
      }}
    >
      <MultiSelectTrigger className="w-full">
        <MultiSelectValue placeholder={placeholder} />
      </MultiSelectTrigger>
      <MultiSelectContent>
        <MultiSelectGroup>
          {options
            .filter((option) => option) // remove falsey values
            .map((option) => (
              <MultiSelectItem key={option} value={option}>
                {formatLabel ? formatLabel(option) : option}
              </MultiSelectItem>
            ))}
        </MultiSelectGroup>
      </MultiSelectContent>
    </MultiSelect>
  );
}
